// define your appwise contants here

import { ValueType } from "@/types/common.types";

export const PAGE_SIZE = 10;

export const ERROR_CODE = {
  INVALID_CREDENTIALS: "InvalidCredentials",
  ACCESS_CODE_EXPIRED: "AccessCodeExpired",
  UNEXPECTED_ERROR: "UnexpectedError",
};

export const valueLabel: Record<ValueType, string> = {
  mrp: "MRP",
  asp: "ASP",
  discount: "Discount",
};

// Brand-aligned categorical palette: accent blue + ink + neutrals (no rainbow).
// DESIGN.md — blue is the signal, ink is primary; charts use a blue/neutral scale.
export const COLORS = [
  "#1A5BFA", // accent (primary)
  "#111827", // ink / text
  "#9CA3AF", // gray
  "#BFDBFE", // accent soft
  "#4B5563", // muted
  "#1E3A8A", // deep blue
  "#D1D5DB", // light gray
  "#60A5FA", // mid blue
  "#374151", // dark gray
  "#93C5FD", // pale blue
  "#6B7280", // gray
  "#1D4ED8", // blue
];

export const COLOR_MAP = {
  SUCCESS: "bg-[#02C17D1A] text-uiColors-green-dark",
  FAILURE: "bg-uiColors-red-lighter text-uiColors-red-default",
  INPROGRESS: "bg-uiColors-yellow-lighter text-yellow-800",
};
export const STATUS_DISPLAY_MAP = {
  SUCCESS: "COMPLETED",
  FAILURE: "FAILED",
  INPROGRESS: "IN PROGRESS",
};
